import React from "react";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";

export interface ElectrictySupplyConfirmationPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  processes?: ProcessStepsProps[];
  wantToReport?: GreyCardProps;
  faqs?: FaqAccordionGroupProps;
}

export const ElectrictySupplyConfirmationPage: React.FC<ElectrictySupplyConfirmationPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  processes,
  wantToReport,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {wantToReport && <GreyCard {...wantToReport} />}
    </ServiceCataloguePageWrapper>
  );
};
